/**
 * FillArea.js
 * Created on 23-apr-2014
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/
 export default class FillArea extends createjs.Rectangle {

    constructor(rect, type) {
        super(rect.x, rect.y, rect.width, rect.height);
        this.type = type;
    }

}

FillArea.WIDTH = "WIDTH";//stretches width only
FillArea.HEIGHT = "HEIGHT";//stretches height only
FillArea.STRETCH = "STRETCH";//stretches both width and height
FillArea.PROPORTIONAL_INSIDE = "PROPORTIONAL_INSIDE";//fit target in rectangle
FillArea.PROPORTIONAL_OUTSIDE = "PROPORTIONAL_OUTSIDE";//fit target around rectangle
